/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/snowmobile_medium'
export default icon
